export default __webpack_public_path__ + "static/media/footer-instagram.56cb9ef2.svg";